import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  strategy: PropTypes.shape({
    title: PropTypes.string.isRequired,
    is_pro: PropTypes.bool.isRequired,
    is_premium: PropTypes.bool.isRequired,
  }).isRequired,
};

const defaultProps = {};
const Header = ({ strategy }) => {
  const { title, is_pro: isPro, is_premium: isPremium } = strategy;

  const renderLabel = () => {
  switch (true) {
    case isPremium:
      return (
          <div className="premium">
          <img src="../crowns.png" className="crown" alt="" />{' '}
          <span className="d-none d-md-block">PREMIUM</span>
        </div>
      )
    case isPro:
      return (
        <div className="pro">
          <img src="../crowns.png" className="crown" alt="" /> <span className="d-none d-md-block">PRO</span>
        </div>
      )  
    default:
    return (<></>)
  }
}
  return (
    <div className="mps-header-inner">
      <h5 className="card-title">{title || '-'}</h5>
      {renderLabel()}
    </div>
  );
};

Header.propTypes = propTypes;
Header.defaultProps = defaultProps;

export default Header;
